// src/api/auth.js
import API from "../axiosConfig";

export const getPublicInstitutions = async () => {
  try {
    const response = await API.get("/public-institutions");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const createPublicInstitution = async (payload) => {
  try {
    const response = await API.post("/public-institutions", { ...payload });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const updatePublicInstitution = async (payload) => {
  try {
    const response = await API.put(`/public-institutions/${payload.id}`, {
      ...payload,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};
